import { render, staticRenderFns } from "./AccountPublishOrgaForm.vue?vue&type=template&id=67330319&"
import script from "./AccountPublishOrgaForm.vue?vue&type=script&lang=ts&"
export * from "./AccountPublishOrgaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports